export default "__VITE_ASSET__BkjrZ5VN__"